import * as React from 'react'

import { Box, type Colors, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import AccessInfo from 'modules/documents/components/DocumentTemplates/Content/AllAvailableVariablesList/Table/TableRow/AccessInfo'
import type Variable from 'modules/documents/store/models/Variable'

interface Props {
  variable: Variable
  variableValues: { [key: string]: string } | undefined
}

interface VariableLabelInfo {
  label: string
  color: Colors
}

export enum Access {
  Full = 'full',
  NoAccess = 'no_access',
  Partial = 'partial',
  Public = 'public',
}

export const PreviewVariable = ({ variable, variableValues }: Props) => {
  const variableLabelInfo = (variable: Variable): VariableLabelInfo => {
    const defaultColor = 'grey1000'
    const fadedColor = 'grey700'

    if (variableValues == undefined)
      return { label: variable.attributes.variable, color: defaultColor }

    if (!Object.keys(variableValues).includes(variable.attributes.variable)) {
      return {
        label: i18n.t('documents.document_templates.variables_list.no_permission'),
        color: fadedColor,
      }
    }

    const label = variableValues[variable.attributes.variable]

    if (!label) {
      return {
        label: i18n.t('documents.document_templates.variables_list.no_value'),
        color: fadedColor,
      }
    }

    return { label: label, color: defaultColor }
  }

  const access = (variable: Variable) => {
    if (variableValues == undefined) return variable.attributes.access

    if (!Object.keys(variableValues).includes(variable.attributes.variable)) {
      return Access.NoAccess
    }

    if (variable.attributes.access == Access.Public) return Access.Public

    return Access.Full
  }
  return (
    <>
      <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
        <Box flexDirection="row" alignItems="center" gap="s4">
          {variable.attributes.is_custom_field && (
            <Icon.Medium icon="input-field" color={'grey800'} />
          )}
          <Text.Normal>{variable.attributes.name}</Text.Normal>
        </Box>

        <AccessInfo
          access={access(variable)}
          permission={variable.attributes.permission_label}
        ></AccessInfo>
      </Box>

      <Text.Normal color={variableLabelInfo(variable).color}>
        {variableLabelInfo(variable).label}
      </Text.Normal>
    </>
  )
}
